<template>
    <div>
        <!-- <el-tabs v-model="activeTab" class="report-tabs" @tab-click="handleTabClick"> -->
            <!-- <el-tab-pane label="财务报表" name="finance" class="tab-pane"> -->
                <!-- 财务报表内容区域 -->
                <!-- </el-tab-pane> -->
            <!-- <el-tab-pane label="审计报表" name="audit" class="tab-pane"> -->
                <!-- 审计报表内容区域 -->
                <!-- </el-tab-pane> -->
        <!-- </el-tabs> -->
        <div style="display: flex;">
          <div class="report-title" :style="activeTab === 'finance' ? 'opacity:1;z-index:1' : 'opacity:0.5;z-index:0'" @click="handleTabClick('finance')">
            <img src="@/assets/financial_tab.png" alt="" style="width: 150px; height: 36px;vertical-align: bottom;">
            <div class="report-title-text">财务报表</div>
          </div>
          <div class="report-title" style="left:-30px" :style="activeTab === 'audit' ? 'opacity:1;z-index:1' : 'opacity:0.5;z-index:0'" @click="handleTabClick('audit')">
            <img src="@/assets/financial_tab.png" alt="" style="width: 150px; height: 36px;vertical-align: bottom;">
            <div class="report-title-text">审计报表</div>
          </div>
        </div>
        <div class="report-tabs-container">
            <!-- 使用Element UI的Tabs组件实现切换功能 -->
            
        </div>
    </div>
</template>
<script>
    import {Message} from "element-ui";

    export default {
        props: [],
        data() {
            return {
                // 默认激活的标签页
                activeTab: 'finance'
            };
        },
        created() {},
        methods: {
            // 处理标签页切换事件
            handleTabClick(tab) {
              this.activeTab = tab;
                // console.log('切换到报表:', tab);
                // 可以在这里添加切换报表时的额外逻辑
                this.$emit('tab-click', tab);
            },
          onUnder() {
            Message.info('功能开发中，敬请期待！');
          },
        }
    }
</script>
<!-- vuecommh120.vue -->
<style>
.report-tabs-container {
  background-color: rgba(0, 0, 0, 0.7);
  /* 深色背景 */
  padding: 20px;
  border-radius: 6px;
  /* width: fit-content; */
  height: 600px;
}

/* 自定义Tabs样式 */
.report-tabs {
  --el-tabs-header-height: 50px;
}

/* 标签页头部样式 */
::v-deep .el-tabs__header {
  background: transparent;
  margin-bottom: 0;
}

/* 标签项样式 */
::v-deep .el-tabs__item {
  color: #ffffff;
  font-size: 16px;
  padding: 0 30px;
  height: 50px;
  line-height: 50px;
  background: linear-gradient(135deg, #0d47a1 0%, #1976d2 100%);
  margin-right: 2px;
  border-radius: 6px 6px 0 0;
  transition: all 0.3s ease;
}

/* 标签项样式 */
::v-deep .el-tabs__nav-wrap::after {
  content: "";
  display: block;
  height: 0 !important;
  visibility: hidden;
}

/* 激活的标签项样式 */
::v-deep .el-tabs__item.is-active {
  background: linear-gradient(135deg, #1565c0 0%, #2196f3 100%);
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* 标签项悬停样式 */
::v-deep .el-tabs__item:hover {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  color: #ffffff;
}

/* 标签指示器样式（隐藏默认指示器） */
::v-deep .el-tabs__active-bar {
  display: none;
}

/* 内容区域样式 */
.report-content {
  background-color: #1e3a8a;
  color: #e0e0e0;
  padding: 20px;
  min-height: 700px;
  border-radius: 0 6px 6px 6px;
}

.report-title {
  position: relative;
}

.report-title-text {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px;
  display: flex;
  align-items: center;

  font-size: 16px;
  color: #ffffff;
}
</style>



